import type { RelationshipInput } from '@/lib/api/domains/entities';

/*
 * E02.F04 R10 / R14 — the fixed relationship-kind vocabulary offered when a
 * relationship is recorded from the both-directions view. The entities feature
 * owns its own copy (a feature never imports another feature — AGENTS.md); it
 * mirrors the domain service's fixed vocabulary exactly: services, manages,
 * uses — never `owns` (AC-953c5f6e), and a compile-time constant, never
 * configurable (AC-a22b7f8d). The server is the authority and refuses an
 * out-of-vocabulary kind regardless.
 */

export type RelationshipKind = RelationshipInput['kind'];

export const entityRelationshipKinds: ReadonlyArray<{
  value: RelationshipKind;
  label: string;
}> = [
  { value: 'services', label: 'Services' },
  { value: 'manages', label: 'Manages' },
  { value: 'uses', label: 'Uses' },
] as const;
